<template>
    <div class="text-center">
        <h1>The requested page does not exist</h1>
        <router-link to="/" class="block link-internal">Return to the Home Page</router-link>
    </div>
</template>

<script>
    export default {
      name: 'PageNotFound',
      title: 'Page Not Found'
    }
</script>